import React from 'react';
import PropTypes from 'prop-types';
import MuiDivider from '@mui/material/Divider';

const Divider = ({sx}) => {
    return (
        <MuiDivider sx={sx}/>
    );
};

Divider.propTypes = {
    sx: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]),
};

export default Divider;
